<template>
  <div>
    <top-message />
    <!--企业-->
    <div class="bottomPart">
      <div class="titlePart">征信授权</div>
      <el-divider />
      <div class="centerPart">
        <div>
          <img
            src="../../assets/images/progress.png"
            alt=""
            style="width: 100%"
          />
          <el-steps
            :active="currentStep"
            align-center
          >
            <el-step
              title="选择授权对象"
              description=""
            />
            <el-step
              title="上传授权书"
              description=""
            />
            <el-step
              title="上传经营执照"
              description=""
            />
            <el-step
              title="上传经办人身份证"
              description=""
            />
          </el-steps>
        </div>

        <el-form
          :model="submitForm"
          label-position="top"
        >
          <!--步骤一-->
          <div
            v-show="currentStep === 0"
            class="formPart"
          >
            <el-form-item label="授权对象">
              <!-- <el-select
                v-model="submitForm.bankCode"
                placeholder="信易贷金融服务平台"
                style="width: 100%"
                disabled
              >
                <el-option
                  v-for="(item, index) in bankObject"
                  :key="index"
                  :label="item.bankName"
                  :value="item.bankCode"
                />
              </el-select> -->
              <el-input
                v-model="bankNames"
                placeholder="信易贷金融服务平台"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="基本开户行">
              <el-select
                v-model="submitForm.openBank"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in bankOptions"
                  :key="index"
                  :label="item.bankName"
                  :value="item.bankCode"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="授权截止日期">
              <el-date-picker
                v-model="submitForm.endDate"
                :default-value="now"
                type="date"
                placeholder="选择日期"
                style="width: 100%"
                :editable="false"
                :picker-options="pickerOptions"
              />
            </el-form-item>
          </div>
          <!--步骤二-->
          <div
            v-show="currentStep === 1"
            class="contentPart"
          >
            <div
              style="display: flex;flex-direction: column;justify-content: center"
            >
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="handleDown"
              >下载授权书模板
              </el-button>
              <el-button
                class="myMainButton"
                style="margin-top: 20px;"
                @click="yangli()"
              >
                <!-- <a
                  :href="baseUrl + '/my/授权书模板.pdf'"
                  target="_blank"
                >查看样例</a> -->
                查看样例
              </el-button>
            </div>
            <image-upload
              describe="上传授权书影印件"
              :type="3"
              label="auth"
              @send="sendValue"
              :url="submitForm.authFile"
            />
          </div>
          <!--步骤三-->
          <div
            v-show="currentStep === 2"
            style="display: flex;justify-content: center;padding: 20px 0"
          >
            <image-upload
              describe="上传经营执照"
              :type="4"
              label="businessLicense"
              @send="sendValue"
              :url="submitForm.licensePath"
            />
          </div>
          <!--步骤四-->
          <div
            v-show="currentStep === 3"
            style="padding: 50px 200px"
          >
            <el-form-item label="经办人姓名">
              <el-input
                v-model="submitForm.operatorName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <div style="display: flex;justify-content: space-between">
              <card-upload
                name="face"
                :type="2"
                @send="sendValue"
                label="operatorIdFront"
                :url="submitForm.frontPath"
              />
              <card-upload
                name="back"
                :type="2"
                @send="sendValue"
                label="operatorIdBack"
                :url="submitForm.backPath"
              />
            </div>
            <div style="margin-top: 10px">支持jpg、png格式，单张文件大小不得超过1M。</div>
          </div>
        </el-form>
      </div>
      <el-divider />
      <div class="footPart">
        <el-button
          class="myMainButton"
          @click="save"
        >保存
        </el-button>
        <div
          v-if="currentStep < 3"
          @click="goNext"
          class="nextButton"
        >下一步
        </div>
        <div
          v-else
          style="display: flex;align-items: center"
        >
          <!-- <div>
            <el-checkbox v-model="submitForm.isRead" />
            <span>我已同意<a
                style="color: #2981EE;cursor: pointer">征信APP实名认证协议</a></span>
          </div> -->
          <el-button
            @click="handleSubmit"
            :loading="submitLoading"
            type="primary"
            class="myPrimaryButton"
            style="margin-left: 10px"
          >提交
          </el-button>
        </div>
      </div>
      <el-dialog
        custom-class="dialog1"
        :show-close="false"
        :visible.sync="dialogVisible"
        width="450px"
        :modal-append-to-body="false"
        :lock-scroll="false"
      >
        <img
          src="../../assets/images/show_icon.png"
          alt=""
          style="width: 100px;height: 100px;"
        />
        <div style="color: #2A2A2A;font-size: 26px;font-weight: bold">授权书申请提交成功
        </div>
        <div style="color: #2A2A2A;font-size: 22px">等待系统审核</div>
        <el-button
          type="primary"
          class="myPrimaryButton"
          @click="goPath"
        >查看审核进度
        </el-button>
      </el-dialog>
      <el-dialog
        custom-class="dialog2"
        :show-close="false"
        :visible.sync="showVisible"
        width="590px"
        :modal-append-to-body="false"
        :lock-scroll="false"
      >
        <img
          src="../../assets/images/sample.png"
          alt=""
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ImageUpload from "../ImageUpload";
import CardUpload from "../CardUpload";
import { getObjectList, getBankList, addAuth, updateAuth, getAuth } from "../../api/myCenter";
import TopMessage from "@/components/TopMessage";
import baseUrl from "@/api/baseUrl";
export default {
  components: { ImageUpload, CardUpload, TopMessage },
  data () {
    return {
      currentStep: 0,
      dialogVisible: false,
      showVisible: false,
      submitForm: {
        bankCode: "",
        openBank: "",
        auth: "",
        businessLicense: "",
        operatorIdFront: "",
        operatorIdBack: "",
        operatorName: "",
        // isRead: false,
        endDate: ""
      },
      bankOptions: [],  // 银行
      bankNames: '信易贷金融服务平台',
      objectOptions: [],  // 授权对象
      submitLoading: false,  // 提交loading
      pickerOptions: {
        disabledDate (date) {
          let now = new Date();
          now = new Date(now.setFullYear(now.getFullYear() + 1));
          now = new Date(now.setDate(now.getDate() - 2));
          return date.getTime() < now.getTime();
        },
      },
      now: new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    }
  },
  computed: {
    getUser: function () {
      return JSON.parse(sessionStorage.getItem("user"))
    },
    getSourceType: function () {
      return sessionStorage.getItem("sourceType")
    }
  },
  created () {
    // this.getObjectList();
    this.getBankList();
    const id = this.$store.state.auth.authId;
    if (id) {
      getAuth({ id }).then(res => {
        res = this.paramDecrypt(res);
        this.submitForm = res.data;
      });
    }
    if (this.getSourceType == 1) {
      this.submitForm.bankCode = this.getUser.sstCustom.oucode
    }
  },
  methods: {
    yangli () {
      window.open(baseUrl + '/my/授权书模板.pdf')
    },
    getObjectList () {
      const params = this.sendParam({ timeStamp: new Date().getTime() });
      getObjectList(params).then((res) => {
        res = this.paramDecrypt(res);
        this.objectOptions = res.data;
      });
    },
    getBankList () {
      const params = this.sendParam({ timeStamp: new Date().getTime() });

      getBankList(params).then((res) => {
        res = this.paramDecrypt(res);
        this.bankOptions = res.data;
      });
    },
    getStatus (index) {
      let status = "wait";
      if (this.currentStep === index) {
        status = "finish";
      } else if (this.currentStep > index) {
        status = "success";
      }
      return status;
    },
    // 保存
    save () {
      const params = {
        webAuthTmp: {
          ...this.submitForm,
          status: this.submitForm.id && this.submitForm.status > this.currentStep ? this.submitForm.status : this.currentStep,
        },
        operateType: 1,
      };
      updateAuth(this.sendParam(params)).then(res => {
        console.log(params)
        res = this.paramDecrypt(res);
        if (res.code === 200) {
          this.$message.success("保存成功");
        }
      })
    },
    // 下一步
    goNext () {
      if (this.currentStep === 0) {
        if (!this.submitForm.bankCode) {
          this.$message.warning("请选择授权对象");
          return;
        }
        if (!this.submitForm.openBank) {
          this.$message.warning("请选择开户行");
          return;
        }
        if (!this.submitForm.endDate) {
          this.$message.warning("请选择截止日期");
          return;
        }
      } else if (this.currentStep === 1) {
        if (!this.submitForm.auth) {
          this.$message.warning("请上传授权书");
          return;
        }
      } else if (this.currentStep === 2) {
        if (!this.submitForm.businessLicense) {
          this.$message.warning("请上传经营执照");
          return;
        }
      }
      this.currentStep++;
    },
    // 提交
    handleSubmit () {
      if (!this.submitForm.operatorName) {
        this.$message.warning("请输入经办人姓名");
        return;
      }
      if (!this.submitForm.operatorIdFront || !this.submitForm.operatorIdBack) {
        this.$message.warning("请上传身份证");
        return;
      }
      // if (!this.submitForm.isRead) {
      //   this.$message.warning("请阅读协议");
      //   return;
      // }
      this.submitLoading = true;
      if (this.submitForm.id) {
        const params = {
          operateType: 2,
          auth: {
            ...this.submitForm,
            examine_status: 0,
          }
        };
        updateAuth(this.sendParam(params)).then(res => {
          this.dialogVisible = true;
          this.submitLoading = false;
        }).catch(err => {
          this.submitLoading = false;
        });
      } else {
        addAuth(this.sendParam(this.submitForm)).then((res) => {
          this.dialogVisible = true;
          this.submitLoading = false;
        }).catch((err) => {
          this.submitLoading = false;
        })
      }
    },
    // 下载时添加token
    handleDown () {
      const xhr = new XMLHttpRequest();
      // xhr.open("get", this.baseUrl + "/api/v1/file/ ", true);  // get、post都可/api/v1/file/authFileTemp
      xhr.open("get", this.baseUrl + "/api/v1/file/authFileTemp ", true);  // get、post都可
      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "企业授权书模板.pdf";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send();
    },
    showSample () {
      // this.showVisible = true;
    },
    // 上传赋值
    sendValue (key, value) {
      this.submitForm[key] = value;
    },
    goPath () {
      this.$emit("send", "historyRecord");
    },
  },
  destroyed () {
    this.$store.commit("setAuthId", "");
  }
}
</script>

<style lang="less" scoped>
.bottomPart {
  width: 100%;
  //min-height: 720px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px 0;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;

  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
  }

  .el-divider {
    background-color: #f3f4f9;
  }

  .formPart {
    padding: 50px 250px;
  }

  .contentPart {
    padding: 20px 50px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    button {
      width: 160px;
      margin: 0;
    }

    .myMainButton {
      a {
        text-decoration: none !important;
        color: #2981ee;
      }
    }
  }

  .footPart {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;

    .nextButton {
      height: 36px;
      background: url("../../assets/images/button_bg.png") 100% no-repeat;
      width: 120px;
      line-height: 36px;
      text-align: center;
      color: #fff;
      border-radius: 6px;
      cursor: pointer;
    }

    label {
      margin-right: 4px;
    }
  }
}

/deep/ .el-steps {
  padding: 0 80px;
  position: relative;
  top: -20px;

  .el-step__line {
    display: none;
  }

  .el-step__line-inner {
    border-color: #dbdbdb;
  }

  .el-step__icon {
    color: #fff;
    top: -5px;
    border-width: 5px;
    box-sizing: content-box;
  }

  .is-success .el-step__icon {
    background: #3bc37b;
    border-color: #bcecd2;
  }

  .is-finish .el-step__icon {
    //background: #2981EE;
    //border-color: #ABC9EF;
    background: #3bc37b;
    border-color: #bcecd2;
  }

  .is-process .el-step__icon {
    //background: #F85B4B;
    //border-color: #F2C8C3;
    background: #2981ee;
    border-color: #abc9ef;
  }

  .is-wait .el-step__icon {
    background: #a7a7a7;
    border-color: #dbdbdb;
  }

  .el-step__title {
    font-size: 16px;
    font-weight: 540;
  }

  .el-step__title.is-success {
    //color: #3BC37B;
  }

  .el-step__title.is-finish {
    //color: #2981EE;
    color: #3bc37b;
  }

  .el-step__title.is-process {
    //color: #F85B4B;
    color: #2981ee;
  }

  .el-step__title.is-wait {
    color: #a7a7a7;
  }

  .el-step__description {
    padding-left: 10px !important;
    padding-right: 10px !important;
    color: #252525;
  }
}

/deep/ .el-dialog {
  border-radius: 8px;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    width: 450px;
    height: 320px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
}

/deep/ .dialog2 {
  .el-dialog__body {
    width: 590px;
    height: 880px;
    padding: 0;
  }
}
</style>
